import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row } from "reactstrap"

import ServiceStructure from "../../../components/Services/structure/ServiceStructure"

const ImportInfo = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>License | Import</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">Import License</h6>

                <ServiceStructure
                  detailsType="import"
                  url="licensing-import-apply"
                  serviceType="Import License"
                  department="Environmental Compliance  &amp; Enforcement Division"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ImportInfo
